import TaskBase from "./TaskBase";
import Urls from "./Urls";
import { AuthManager } from "@cuatroochenta/co-admin-react-library";

export default class TaskMenu extends TaskBase {

    public getMenu(centerId: number | undefined) {
        let url = `${Urls.URL_GET_MENU}?key=${Date.now()}`;
        if (centerId) {
            url += `&center_id=${centerId}`
        }
        return fetch(url, this.getRequestInfo())
            .then(async (response) => {
                if (response.ok && response.headers.get('Content-Type')?.includes('application/pdf')) {
                    const blob = await response.blob();
                    const arrayBuffer = await blob.arrayBuffer();
                    return new Uint8Array(arrayBuffer);
                }
                return response.json();
            })
            .then(data => {return data});
    }

    public updateMenu(centerId: number | undefined, file: File) {
        const formData = new FormData();
        formData.append("menu", file);

        return fetch(`${Urls.URL_UPDATE_MENU}${centerId ? '?center_id=' + centerId : ''}`, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + AuthManager.getAuthToken()
            },
            body: formData
        })
        .then(response => response.json())
        .then(data => {return data});
    }

}